import { Button, TablePagination } from "@material-ui/core";
import { SaveAlt } from "@material-ui/icons";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import CalendarToday from "@material-ui/icons/CalendarToday";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import axios from "axios";
import "flatpickr/dist/flatpickr.min.css";
import MaterialTable, { MTableToolbar } from "material-table";
import moment from "moment";
import numeral from "numeral";
import React, { Component, forwardRef } from "react";
import Flatpickr from "react-flatpickr";
import Clamp from "react-multiline-clamp";
import { awsUrl2 } from "../../config";
import { sanitizeInput } from "../../utils/sanitizeInput";
import { createTimeStamp } from "../common/timeStampHelper";

let ismobile_font = window.innerWidth < 1600;

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  // Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  Filter: () => <div />,
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
const carrierMap = {
  carrier_a: process.env.REACT_APP_MODE == "beta" ? "LD" : "CHUBB",
  carrier_b: process.env.REACT_APP_MODE == "beta" ? "GC" : "FIC",
  carrier_o: process.env.REACT_APP_MODE == "beta" ? "SF" : "State Fund",
};

const reverseCarrierMap = {
  chubb: "carrier_a",
  ld: "carrier_a",
  fic: "carrier_b",
  gc: "carrier_b",
  "state fund": "carrier_o",
  sf: "carrier_o",
};

let selectedRow = [];

const handleClick = (rows) => {
  selectedRow = rows;
};

class DashboardArchive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      searchField: null,
      dateRange: null,
      rowDataList: null,
    };

    this.inputRef = React.createRef();
  }

  componentDidMount = () => {
    sessionStorage.clear();
    this.updateArchiveDisplay();
  };

  camelCase = (str) => {
    return str
      .trim()
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  };

  fontfunction = () => {
    if (window.innerWidth < 1600 && window.innerWidth > 1500) {
      return "0.86rem";
    }
    if (window.innerWidth < 1500 && window.innerWidth > 1410) {
      return "0.8.2rem";
    }
    if (window.innerWidth < 1410 && window.innerWidth > 1310) {
      return "0.8rem";
    }
    if (window.innerWidth < 1300) {
      return "0.76rem";
    }
  };

  handleInputChange = (e) => {
    this.setState({ searchField: e.target.value }, () => {
      if (this.inputRef.current) {
        this.inputRef.current.focus();
      }
    });
  };

  handleDateChange = (selectedDates) => {
    if (selectedDates.length === 0) return this.setState({ dateRange: null });
    if (selectedDates.length !== 2) return;

    const [start, end] = selectedDates;
    const diffYears = moment(end).diff(moment(start), "days") / 365.25;

    if (diffYears > 2) {
      this.props.updatePopUpData({
        show: true,
        title: "",
        children: (
          <>
            <br></br>
            <span style={{ fontWeight: "bold" }}>
              The date range must not exceed 2 years
            </span>
          </>
        ),
        acceptBtn: "Ok",
        disableNoButton: true,
        acceptBtnCallback: () => {
          this.setState({ dateRange: [] });
        },
      });
      return;
    }
    this.setState({ dateRange: selectedDates });
  };

  searchNewBusinessArchivedRecords = () => {
    const { dateRange, searchField } = JSON.parse(JSON.stringify(this.state));

    axios
      .post(awsUrl2 + `/api/retrieveNewBusinessRecords`, {
        searchField: sanitizeInput(searchField),
        dateRange,
      })
      .then((res) => {
        const responseData = res.data;

        this.setState({
          rowDataList: this.processRowDataListForNewBusiness(responseData.data),
          isLoading: false,
        });
      })
      .catch((error) => {
        console.log("error", error);
        this.setState({
          isLoading: false,
          rowDataList: [],
          searchField: "",
          dateRange: [],
        });
      });
  };

  searchExistingBusinessArchivedRecords = () => {
    const { dateRange, searchField } = JSON.parse(JSON.stringify(this.state));

    axios
      .post(awsUrl2 + `/api/retrieveExistingBusinessRecords`, {
        searchField: sanitizeInput(searchField),
        dateRange,
      })
      .then((res) => {
        const responseData = res.data;

        this.setState({
          rowDataList: this.processRowDataListForExistingBusiness(
            responseData.data
          ),
          isLoading: false,
        });
      })
      .catch((error) => {
        console.log("error", error);
        this.setState({
          isLoading: false,
          rowDataList: [],
          searchField: "",
          dateRange: [],
        });
      });
  };

  onSearch = () => {
    const { tabName } = this.props;
    const { dateRange, searchField } = JSON.parse(JSON.stringify(this.state));

    if (!searchField && (!dateRange || dateRange.length !== 2)) return;

    this.setState({ isLoading: true });

    if (tabName === "tab1") this.searchNewBusinessArchivedRecords();
    else this.searchExistingBusinessArchivedRecords();
  };

  onUnarchive = () => {
    const { tabName } = this.props;
    const { rowDataList } = this.state;
    this.setState({
      isLoading: true,
    });
    let path = "";

    if (tabName === "tab1") path = "/api/newBusiness/unarchive";
    else path = "/api/existingBusiness/unarchive";

    axios
      .post(awsUrl2 + path, {
        id: selectedRow.map((row) => {
          return {
            client_id: row.clientId,
            effective_date: row.effectiveDate,
          };
        }),
      })
      .then((res) => {
        this.setState((prevState) => {
          const updatedList = prevState.rowDataList.filter((item) => {
            return !selectedRow.some(
              (selected) =>
                selected.clientId === item.clientId &&
                selected.effectiveDate === item.effectiveDate
            );
          });

          return { rowDataList: updatedList };
        });
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  setTableData = () => {
    let {
      rowDataList = [],
      isLoading,
      searchField,
      dateRange,
    } = JSON.parse(JSON.stringify(this.state));

    let { tabName } = this.props;

    var rowCount = 10;

    var rowArray = [25, 50, 75, 100];

    var rowLength = rowDataList ? rowDataList.length : 10;

    if (rowLength < 10) {
      rowCount = rowLength;
      rowArray = [rowCount, ...rowArray];
    }

    let columns = {
      tab1: [
        {
          title: "Created Date (ET)",
          field: "uploadTimestamp",
          defaultSort: "desc",
          render: (rowData) => {
            let visitDate = moment
              .utc(Number(rowData.uploadTimestamp))
              .utcOffset("-0500")
              .format("M/D/YYYY - hh:mm A");
            let date = visitDate.split("-")[0];
            let time = visitDate.split("-")[1];
            return (
              <span>
                {date}
                <br></br>
                {time}
              </span>
            );
          },
          cellStyle: {
            padding: "6px 15px 6px 10px",
            minWidth: "80px",
            maxWidth: "80px",
          },
        },
        {
          title: "Company Name",
          field: "companyName",
          cellStyle: {
            padding: "6px 15px 6px 10px",
            minWidth: "170px",
            maxWidth: "170px",
          },
          render: (rowData) => (
            <Clamp lines={2}>{this.camelCase(rowData.companyName)}</Clamp>
          ),
        },
        {
          title: "Effective Date",
          field: "effectiveDate",
          // defaultSort: "desc",
          cellStyle: {
            padding: "6px 15px 6px 10px",
          },
          render: (rowData) => <Clamp lines={1}>{rowData.effectiveDate}</Clamp>,
        },
        {
          title: "Opportunity ID / IComp ID",
          field: "opportunityId",
          cellStyle: {
            padding: "6px 15px 6px 10px",
            maxWidth: "50px",
            minWidth: "300px",
          },
          render: (rowData) => <Clamp lines={2}>{rowData.opportunityId}</Clamp>,
        },
        {
          title: "Business Start Date",
          field: "businessStartDate",
          cellStyle: {
            padding: "6px 15px 6px 10px",
            minWidth: "80px",
          },
          render: (rowData) => (
            <Clamp lines={1}>{rowData.businessStartDate}</Clamp>
          ),
        },
        {
          title: "Carrier",
          field: "selectedCarrier",
          render: (rowData) => rowData.selectedCarrier || "-",
          cellStyle: {
            padding: "6px",
            wordBreak: "break-all",
            minWidth: "50px",
            width: "80px",
            maxWidth: "80px",
          },
          headerStyle: {
            padding: "6px",
          },
        },
        {
          title: "Modified by",
          field: "modifiedBy",
          render: (rowData) =>
            <Clamp lines={1}>{rowData.modifiedBy}</Clamp> || "-",
          cellStyle: {
            padding: "6px 20px 6px 0px",
            minWidth: "100px",

            //wordBreak: "break-all",
          },
          headerStyle: {
            padding: "6px",
          },
        },
        {
          title: "Status",
          field: "status",
          render: (rowData) => {
            let date = "";
            if (rowData.status === "Bound") {
              let tempDate = rowData.bindDate || rowData.date;
              date = moment.utc(Number(tempDate)).format("M/D/YYYY");
            } else if (rowData.status === "To Salesforce") {
              let tempDate = rowData.sendToSalesforceDate || rowData.date;
              date = moment.utc(Number(tempDate)).format("M/D/YYYY");
            } else if (rowData.status !== "Submitted") {
              date = moment.utc(Number(rowData.date)).format("M/D/YYYY");
            }

            return (
              <div className="d-flex align-items-center">
                <span
                  className="mr-2"
                  style={{
                    height: "18px",
                    width: "18px",
                    backgroundColor: rowData.cellColor,
                    color: rowData.textColor,
                    borderRadius: "50%",
                    display: "inline-block",
                  }}
                ></span>
                <span>
                  {rowData.status}
                  <br></br>
                  {date}
                </span>
              </div>
            );
          },
          cellStyle: (e, rowData) => {
            let style = { padding: "6px 15px 6px 10px" };
            return style;
          },
        },
        {
          title: "Archived Date",
          field: "archivedDate",
          filtering: false,
          // defaultSort: "desc",
          cellStyle: {
            padding: "6px 15px 6px 10px",
          },
          render: (rowData) => {
            return <span>{rowData.archivedDate}</span>;
          },
        },
      ],
      tab2: [
        {
          title: "Created Date (ET)",
          field: "uploadTimestamp",
          defaultSort: "desc",
          filtering: false,
          render: (rowData) => {
            let visitDate = moment
              .utc(Number(rowData.uploadTimestamp))
              .utcOffset("-0500")
              .format("M/D/YYYY - hh:mm A");
            let date = visitDate.split("-")[0];
            let time = visitDate.split("-")[1];
            return (
              <span>
                {date}
                <br></br>
                {time}
              </span>
            );
          },
          cellStyle: {
            padding: "6px 15px 6px 10px",
            minWidth: "80px",
            maxWidth: "80px",
          },
        },
        {
          title: "Company Name",
          field: "companyName",
          filtering: false,
          cellStyle: {
            padding: "6px 15px 6px 10px",
            minWidth: "170px",
            maxWidth: "170px",
          },
          render: (rowData) => (
            <Clamp lines={2}>{this.camelCase(rowData.companyName)}</Clamp>
          ),
        },
        {
          title: "Effective Date",
          field: "effectiveDate",
          filtering: false,
          // defaultSort: "desc",
          cellStyle: {
            padding: "6px 15px 6px 10px",
          },
          render: (rowData) => <Clamp lines={1}>{rowData.effectiveDate}</Clamp>,
        },
        {
          title: "Client ID",
          field: "clientId",
          filtering: false,
          cellStyle: {
            padding: "6px 15px 6px 10px",
            minWidth: "80px",
            maxWidth: "50px",
          },
          render: (rowData) => <Clamp lines={1}>{rowData.clientId}</Clamp>,
        },
        {
          title: "Business Start Date",
          field: "businessStartDate",
          filtering: false,
          cellStyle: {
            padding: "6px 15px 6px 10px",
            minWidth: "80px",
          },
          render: (rowData) => (
            <Clamp lines={1}>{rowData?.businessStartDate}</Clamp>
          ),
        },
        {
          title: "Carrier",
          field: "selectedCarrier",
          filtering: false,
          render: (rowData) => rowData.selectedCarrier || "-",
          cellStyle: {
            padding: "6px",
            wordBreak: "break-all",
            minWidth: "50px",
            width: "80px",
            maxWidth: "80px",
          },
          headerStyle: {
            padding: "6px",
          },
        },
        {
          title: "Modified by",
          field: "modifiedBy",
          render: (rowData) =>
            <Clamp lines={1}>{rowData.modifiedBy}</Clamp> || "-",
          cellStyle: {
            padding: "6px 0",
            //wordBreak: "break-all",
            minWidth: "180px",
            width: "180px",
            maxWidth: "180px",
          },
          headerStyle: {
            padding: "6px 0",
          },
        },
        {
          title: "Status",
          field: "status",
          cellStyle: {
            padding: "6px 10px 6px 0",
            // wordBreak: "break-word",
          },
          headerStyle: {
            padding: "6px 10px 6px 0",
          },
          render: (rowData) => {
            return <span>{rowData.status}</span>;
          },
        },
        {
          title: "Archived Date",
          field: "archivedDate",
          filtering: false,
          // defaultSort: "desc",
          cellStyle: {
            padding: "6px 15px 6px 10px",
          },
          render: (rowData) => {
            return <span>{rowData.archivedDate}</span>;
          },
        },
      ],
    };

    return (
      <MaterialTable
        style={{ marginTop: "20px" }}
        isLoading={isLoading}
        icons={tableIcons}
        data={rowDataList}
        columns={columns[tabName]}
        onSelectionChange={(rows) => {
          handleClick(rows);
        }}
        options={{
          paginationPosition: "both",
          padding: "dense",
          showTitle: false,
          thirdSortClick: false,
          pageSize: rowCount,
          pageSizeOptions: rowArray,
          filtering: false,
          search: false,
          exportButton: {
            csv: true,
            pdf: false,
          },
          headerStyle: {
            fontSize: ismobile_font ? this.fontfunction() : "0.9rem",
            backgroundColor: "#003764",
            color: "#FFF",
            padding: "2px 15px 2px 10px",
          },
          rowStyle: {
            fontSize: "12px",
          },
          searchFieldStyle: {
            fontSize: "12px",
          },
          selection: true,
        }}
        actions={[
          {
            tooltip: "Unarchive",
            icon: () => (
              <button className="btn btn-sm btnConfirmAll">Unarchive</button>
            ),
            onClick: () => {
              this.props.updatePopUpData({
                show: true,
                title: "Do you wish to continue?",
                children: (
                  <>
                    <br></br>
                    <span style={{ fontWeight: "bold" }}>
                      {`Selected records will be unarchived`}
                    </span>
                  </>
                ),
                acceptBtn: "Yes",
                acceptBtnCallback: () => {
                  this.onUnarchive();
                },
              });
            },
          },
        ]}
        components={{
          Toolbar: (props) => (
            <div
              className={"d-flex flex-row gap-3 justify-content-between w-100"}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  paddingLeft: "10px",
                  paddingRight: "20px",
                }}
              >
                <div
                  className="d-flex align-items-center border"
                  style={{ width: "auto", borderRadius: "4px" }}
                >
                  <Flatpickr
                    value={dateRange}
                    onChange={this.handleDateChange}
                    className="custom-flatpickr"
                    placeholder="Effective Date"
                    style={{
                      width: "200px",
                      height: "38px",
                    }}
                    options={{
                      mode: "range",
                      dateFormat: "m-d-Y",
                      maxDate: moment().toDate(), // Max today
                    }}
                  />
                  <CalendarToday
                    style={{ color: "gray" }}
                    className="calendar-icon ms-2 px-1 "
                  />
                </div>
                <input
                  ref={this.inputRef}
                  type="text"
                  style={{
                    width: "272px",
                    height: "38px",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                  title={`FEIN, Company name, ${
                    tabName === "tab1" ? "Opportunity" : "Client"
                  } Id`}
                  placeholder={`FEIN, Company name, ${
                    tabName === "tab1" ? "Opportunity" : "Client"
                  } Id`}
                  value={searchField}
                  onChange={this.handleInputChange}
                  onKeyDown={(e) => {
                    if (e.key !== "Enter") return;
                    this.onSearch();
                  }}
                />
                <Button
                  className="btn btn-sm btnConfirmAll"
                  color="primary"
                  onClick={this.onSearch}
                >
                  Search
                </Button>
              </div>

              <div className="w-100">
                <MTableToolbar {...props} />
              </div>
            </div>
          ),
          Pagination: (props) => (
            <TablePagination
              {...props}
              labelRowsPerPage={
                <span style={{ fontSize: 12 }}>{props.labelRowsPerPage}</span>
              }
              labelDisplayedRows={(row) => (
                <span style={{ fontSize: 12 }}>
                  {props.labelDisplayedRows(row)}
                </span>
              )}
              SelectProps={{
                style: {
                  fontSize: 12,
                },
              }}
            />
          ),
        }}
      />
    );
  };

  firstCaps = (str) => {
    return str ? str[0].toUpperCase() + "" + str.slice(1).toLowerCase() : "";
  };

  updateArchiveDisplay = () => {
    this.setState({
      ...this.state,
      rowDataList: [],
      isLoading: false,
    });
  };

  processRowDataListForNewBusiness = (dataFromAPI) => {
    const rowDataList = [];

    for (let key of dataFromAPI) {
      try {
        if (!key.uploadTimestamp) continue;
        let cellColor;
        let textColor;
        let status = key.status;
        if (key.existing === "true") {
          status = "Bound";
          cellColor = "rgb(25, 101, 1)";
          textColor = "white";
        } else if (status === "sent_to_salesforce") {
          status = "To Salesforce";
          cellColor = "rgb(255, 214, 0)";
        } else if (status === "quote_generated") {
          status = "In Progress";
          cellColor = "#00b7eb";
        } else {
          status = "Submitted";
          cellColor = "rgb(1, 0, 138)";
          textColor = "white";
        }

        let tempRow = {
          archivedDate: key.deleteTimestamp
            ? moment.utc(key.deleteTimestamp).format("M/D/YYYY")
            : "-",
          selectedCarrier: key.selectedCarrier
            ? carrierMap[key.selectedCarrier]
            : "-",
          modifiedBy: key.modifiedByName || key.modifiedBy || "-",
          companyName:
            key.companyProfile &&
            key.companyProfile.companyName &&
            key.companyProfile.companyName.value
              ? key.companyProfile.companyName.value
              : "N/A",
          effectiveDate: key.effective_date
            ? moment.utc(key.effective_date).format("M/D/YYYY")
            : "-",
          opportunityId: (key.companyProfile && key.companyProfile.emailId
            ? key.companyProfile.emailId.value
            : key?.companyProfile?.opportunity_id?.value || ""
          ).toLowerCase(),
          businessStartDate: key?.companyProfile?.yearBusinessEstablished?.value
            ? moment
                .utc(key?.companyProfile?.yearBusinessEstablished?.value)
                .format("M/D/YYYY")
            : "-",
          status,
          cellColor,
          textColor,
          date: key.timestamp,
          emodStatesData: key.emodStatesData,
          childrenLoc: key.payrollData,
          companyProfile: key.companyProfile,
          historicalClaims: key.historicalClaims || {},
          historicalClaimsCheck: key.historicalClaimsCheck || {},
          uploadTimestamp: key?.uploadTimestamp,
          sendToSalesforceDate: key.sendToSalesforceDate,
          bindDate: key.bindDate,
          isSalesforce: key.isSalesforce,
          existingStatus: key.existing,
          clientId: (key.companyProfile && key.companyProfile.emailId
            ? key.companyProfile.emailId.value
            : key?.companyProfile?.opportunity_id?.value || ""
          ).toLowerCase(),
          client_ID: key.client_id || "",
          updatedBusinessStartDate:
            key.companyProfile &&
            key.companyProfile.yearBusinessEstablished &&
            key.companyProfile.yearBusinessEstablished.value
              ? key.companyProfile.yearBusinessEstablished.value.split("T")[0]
              : "",
        };
        createTimeStamp(tempRow, "uploadTimestamp");

        rowDataList.push(tempRow);
      } catch (error) {
        console.log("**error ", error);
      }
    }

    return rowDataList;
  };

  processRowDataListForExistingBusiness = (dataFromAPI) => {
    const rowDataList = [];
    for (let key of dataFromAPI) {
      let clientPayroll = 0;
      for (let stateIndex in key.payrollData) {
        try {
          for (let classCodeIndex in key.payrollData[stateIndex]
            .classCodesInfo) {
            clientPayroll = numeral(
              key.payrollData[stateIndex].classCodesInfo[classCodeIndex].payroll
                .value
            )
              .add(clientPayroll)
              .value();
          }
        } catch (error) {
          console.log("++ep", error);
          continue;
        }
      }

      let tempRow = {
        archivedDate: key.deleteTimestamp
          ? moment.utc(Number(key.deleteTimestamp)).format("M/D/YYYY")
          : "-",
        selectedCarrier: key.selectedCarrier
          ? carrierMap[key.selectedCarrier]
          : "-",
        companyName: key.companyProfile.companyName.value,
        effectiveDate: key.effective_date
          ? moment.utc(key.effective_date).format("M/D/YYYY")
          : "-",
        clientId: key.client_id,
        status: key.status,
        businessStartDate: key?.companyProfile?.yearBusinessEstablished?.value
          ? moment
              .utc(key?.companyProfile?.yearBusinessEstablished?.value)
              .format("M/D/YYYY")
          : "-",
        modifiedBy: key.modifiedByName || key.modifiedBy || "-",
        clientPayroll,
        uploadTimestamp: key.uploadTimestamp,
      };

      // set the upload status
      if (
        tempRow.status &&
        tempRow.status.toLowerCase() !== "validation_error"
      ) {
        if (
          tempRow.status.toLowerCase() === "quote_generated" &&
          typeof tempRow.errorStatus === "object" &&
          tempRow.errorStatus.length > 0 &&
          tempRow.errorStatus.includes("Details have been defaulted")
        ) {
          tempRow.status = "Quote Generated, Details Have Been Defaulted";
        }
        tempRow.status = this.camelCase(
          tempRow.status.split("_").join(" ")
        ).trim();
      } else if (typeof tempRow.errorStatus === "object") {
        if (tempRow.errorStatus.length === 0) {
          tempRow.status = "Generating Quote";
        } else {
          let ss = "";
          Array.from(new Set(tempRow.errorStatus)).map((ele) => {
            if (ss === "") ss = this.camelCase(ele);
            else ss = ss + ", " + this.camelCase(ele);
          });
          tempRow.status = ss.trim();
        }
      } else {
        tempRow.status = "Validation Error";
      }

      rowDataList.push(tempRow);
    }

    return rowDataList;
  };

  render() {
    let { selected, tabName } = this.props;
    return (
      <div
        className="Extensis-Dashboard"
        style={
          tabName !== selected ? { display: "none", fontSize: "12px" } : {}
        }
      >
        <div>{this.setTableData()}</div>
      </div>
    );
  }
}

export default DashboardArchive;
